import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAffiliateProvider } from "../../providers/AffiliateProvider";
const AffiliateTotalPayments = () => {
	const { paymentsMade } = useAffiliateProvider();
	const { t } = useTranslation();
	return (
		<>
			<Box
				flex={1}
				minWidth="200px"
				maxWidth="376px"
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
					padding: "16px",
					borderRadius: "8px",
					margin: "8px",
				}}
				className="trader-credits-to-be-paid"
			>
				<Typography variant="body1" fontSize="24px">
					{t("affiliate.payments_made")}
				</Typography>
				<Typography variant="body1" fontSize="40px" fontWeight="bold">
					{paymentsMade}
				</Typography>
			</Box>
		</>
	);
};

export default AffiliateTotalPayments;
